export enum LayoutType {
  Square = "square",
  HorizontalSquare = "horizontalSquare",
  VerticalSquare = "verticalSquare",
}
